<template>
  <div class="body-s">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>
